function maybeParseOption(str) {
  try {
    const option = JSON.parse(str);
    return {
      autoplay: option.autoplay !== false,
      loop: option.loop !== false,
      muted: option.muted !== false,
    };
  } catch (e) {
    return {};
  }
}

module.exports = function convertMP4ToVideo(md) {
  const defaultRender =
    md.renderer.rules.text ||
    function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };

  function mp4Video(tokens, idx, options, env, self) {
    const token = tokens[idx];

    if (!/^https:\/\/.+\.mp4/.test(token.content)) {
      return defaultRender(tokens, idx, options, env, self);
    }

    const matched = token.content.match(/^(https:\/\/.+\.mp4)((?: {[^}]+?})?)$/);
    if (!matched) {
      return defaultRender(tokens, idx, options, env, self);
    }

    const url = matched[1];
    if (!url) {
      return defaultRender(tokens, idx, options, env, self);
    }

    let option = {
      autoplay: true,
      loop: true,
      muted: true,
      playsinline: true,
      controls: true,
    };
    const optionStr = matched[2];
    if (optionStr) {
      option = Object.assign({}, option, maybeParseOption(optionStr));
    }

    const attrStr = Object.keys(option).filter((k) => option[k]).join(' ');

    return `<video src="${url}" ${attrStr}>
      <noscript class="loading-lazy">
        <source src="${url}" type="video/mp4" />
      </noscript>
    </video>`;
  }

  md.renderer.rules.text = mp4Video;
};
